import { render, staticRenderFns } from "./SmokingPage.vue?vue&type=template&id=60b4ab28"
import script from "./SmokingPage.vue?vue&type=script&lang=js"
export * from "./SmokingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports